
import { faFolderOpen, faPlus, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    ArrowBack,
    AutoAwesome as AutoAwesomeIcon,
    Casino as CasinoIcon,
    ExpandLess as ExpandLessIcon,
    ExpandMore as ExpandMoreIcon,
    FlashOn as FlashOnIcon,
    HelpOutline as HelpOutlineIcon,
    LocalFireDepartment as LocalFireDepartmentIcon,
    LocalPolice as LocalPoliceIcon,
    Memory as MemoryIcon,
    Menu as MenuIcon,
    PlayArrow as PlayArrowIcon,
    RocketLaunch as RocketLaunchIcon,
    Sailing as SailingIcon,
    SelfImprovement as SelfImprovementIcon,
    Settings as SettingsIcon,
    Warning as WarningIcon,
    WbSunny as WbSunnyIcon,
} from '@mui/icons-material';
import {
    Box,
    Button,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Drawer,

    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Paper,

    TextField,
    Tooltip,
    Typography,
} from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiContext } from './App';



const multiverses = [
    {
        id: 'Witchverse',
        name: 'Witchverse',
        icon: <AutoAwesomeIcon sx={{ mr: 1 }} />,
        description: 'A world of dark magic, cursed rituals, and the eternal battle between witches and those who hunt them.'
    },
    {
        id: 'Westverse',
        name: 'Westverse',
        icon: <WbSunnyIcon sx={{ mr: 1 }} />,
        description: 'A land of lawless duels, untamed frontiers, and supernatural whispers in the desert.'
    },
    {
        id: 'Wuxiaverse',
        name: 'Wuxiaverse',
        icon: <SelfImprovementIcon sx={{ mr: 1 }} />,
        description: 'A world of ancient warriors, legendary duels, and mastery of body and spirit.'
    },
    {
        id: 'Cyberverse',
        name: 'Cyberverse',
        icon: <MemoryIcon sx={{ mr: 1 }} />,
        description: 'A future of neon cities, rogue AI, and digital sorcery where cybernetics enhance the body and mind.'
    },
    {
        id: 'Dragonverse',
        name: 'Dragonverse',
        icon: <LocalFireDepartmentIcon sx={{ mr: 1 }} />,
        description: 'A realm of knights, magic, and legendary beasts, where kingdoms rise and fall.'
    },
    {
        id: 'Starverse',
        name: 'Starverse',
        icon: <RocketLaunchIcon sx={{ mr: 1 }} />,
        description: 'A galaxy of mercenaries, alien empires, and psionic mysteries amidst galactic conflict.'
    },
    {
        id: 'Apocaverse',
        name: 'Apocaverse',
        icon: <WarningIcon sx={{ mr: 1 }} />,
        description: 'A shattered world of radiation storms, scavengers, and the fight for survival.'
    },
    {
        id: 'Viceverse',
        name: 'Viceverse',
        icon: <LocalPoliceIcon sx={{ mr: 1 }} />,
        description: 'A gritty city of crime, corruption, heists, and the blurred line between justice and chaos.'
    },
    {
        id: 'Heroverse',
        name: 'Heroverse',
        icon: <FlashOnIcon sx={{ mr: 1 }} />,
        description: 'A world of legendary heroes and villains, where superpowers shape destiny and justice is never simple.'
    },
    {
        id: 'Waterverse',
        name: 'Waterverse',
        icon: <SailingIcon sx={{ mr: 1 }} />,
        description: 'A realm of oceanic mysteries, naval warfare, and deep-sea horrors lurking beneath the waves.'
    }
];


const archetypesByWorld = {
    Witchverse: [
        {
            id: 'Occultist',
            details: `• Occultists wield forbidden knowledge and magical rites, tapping into powers few dare to understand.

• Starting Skills: Spellcasting & Rituals, Arcane & Occult Knowledge, Alchemy & Potion Making.

• Attributes: Might 5, Reflexes 7, Fortitude 7, Resolve 11, Presence 8, Intellect 11, Guile 7, Perception 10

• Resources: Health 30, Stamina 30, Mind 40

• Sub-Types: Hedge Witch (nature-bound magic and ancestral charms) or Infernal Witch (blood pacts and demonic power).
         `
        }
        ,
        { id: 'Purifier', details: 'Trained to detect and destroy dark forces.' },
        { id: 'Devout', details: 'Channels divine energy to cleanse evil.' },
        { id: 'Medium', details: 'Walks between worlds, communing with the dead.' },
        { id: 'Accursed', details: 'Bound by monstrous transformations and supernatural affliction.' }
    ],
    Westverse: [
        { id: 'Gunslinger', details: 'Quick on the draw or precise at range.' },
        { id: 'Huntsman', details: 'Thrives in the wild, hunting man and beast.' },
        { id: 'Shaman', details: 'Communes with spirits, invoking primal forces.' },
        { id: 'Drifter', details: 'Survives by wit, charm, and deception.' },
        { id: 'Homesteader', details: 'Crafts, farms, and protects their land.' }
    ],
    Wuxiaverse: [
        { id: 'Warrior Monk', details: 'Unarmed master harnessing body and spirit.' },
        { id: 'Weapon Master', details: 'Excels with swords, bows, or classic weapons.' },
        { id: 'Xian', details: 'Supernatural power and gravity-defying grace.' },
        { id: 'Assassin', details: 'Strikes from shadows with deadly efficiency.' },
        { id: 'Trickster', details: 'Outsmarts foes with misdirection and speed.' }
    ],
    Cyberverse: [
        { id: 'Fighter', details: 'Augmented enforcer trained for urban combat.' },
        { id: 'Techie', details: 'A hacker, engineer, or drone-wielding prodigy.' },
        { id: 'Phantom', details: 'Infiltration expert, slips through security and reality unnoticed.' },
        { id: 'Enhancer', details: 'Bio-chemical enhancements push past limits.' },
        { id: 'Synth', details: 'A self-aware AI or engineered clone.' }
    ],
    Dragonverse: [
        { id: 'Fighter', details: 'Excels in martial combat and battlefield control.' },
        { id: 'Mage', details: 'Harnesses elemental, arcane, or necromantic powers.' },
        { id: 'Rogue', details: 'Swift, cunning, and precise with blades or traps.' },
        { id: 'Cleric', details: 'Healer and smiter of evil through sacred power.' },
        { id: 'Ranger', details: 'Skilled archer and master of beasts and terrain.' }
    ],
    Starverse: [
        { id: 'Mercenary', details: 'Tactician or bounty hunter for hire.' },
        { id: 'Android', details: 'Synthetic operative, AI or digital consciousness in humanoid form.' },
        { id: 'Alien', details: 'Strange physiology and powers beyond human understanding.' },
        { id: 'Psion', details: 'Wields telepathy and telekinesis to shape reality.' },
        { id: 'Pilot', details: 'Excels in high-speed, interstellar ship combat.' }
    ],
    Apocaverse: [
        { id: 'Survivor', details: 'Stealthy, hardened, and self-sufficient.' },
        { id: 'Scrapper', details: 'Tech scavenger, repurposes salvage into weapons and tools.' },
        { id: 'Mutant', details: 'Evolved anomaly, twisted by radiation, often gifted or cursed.' },
        { id: 'Scientist', details: 'Engineer, healer, or inventor from the old world.' },
        { id: 'Tribalist', details: 'Thrives within chaotic new-world societies.' }
    ],
    Viceverse: [
        { id: 'Badge', details: 'Law enforcer, officer or detective walking the line of justice.' },
        { id: 'Infiltrator', details: 'Master thief, breaks into vaults and criminal empires undetected.' },
        { id: 'Silencer', details: 'Contract killer, eliminates targets with brutal efficiency.' },
        { id: 'Hustler', details: 'Rises through charm, cons, and connections.' },
        { id: 'Fixer', details: 'Underworld broker, pulls strings behind the scenes and trades secrets.' }
    ],
    Heroverse: [
        { id: 'Titan', details: 'Powerhouse, superhuman strength, resilience, and unstoppable force.' },
        { id: 'Speedster', details: 'Blur of motion, fast enough to bend time and space.' },
        { id: 'Psychic', details: 'Manipulates thought, emotion, and memory.' },
        { id: 'Elemental', details: 'Commands flame, frost, lightning, or stone.' },
        { id: 'Gadgeteer', details: 'Tech-based hero, builds tools and suits to outmatch superpowers.' }
    ],
    Waterverse: [
        { id: 'Buccaneer', details: 'Swashbuckling raider, rules the waves with blade and bravado.' },
        { id: 'Navigator', details: 'Sea guide, reads stars, storms, and secret tides.' },
        { id: 'Tideborn', details: 'Mystic of the deep, wields oceanic magic and ancient power.' },
        { id: 'Seeker', details: 'Undersea explorer, hunts ruins and relics lost to the sea.' },
        { id: 'Hunter', details: 'Beast slayer, tracks and slays the horrors of the deep.' }
    ]
};

const startingLocations = {
    Witchverse: ['Witchcraft Academy', 'Cursed Village', 'Divine Sanctuary', 'Occult Library', 'Dark Shrine'],
    Westverse: ['Saloon', 'Fort', 'Ghost Town', 'Outpost', 'Hideout'],
    Wuxiaverse: ['Monastery', 'Temple', 'Clan Compound', 'Academy', 'Retreat'],
    Cyberverse: ['Tech Hub', 'Data Center', 'Cyberpunk City', 'Augmented District', 'Virtual Realm'],
    Dragonverse: ['Castle', 'Keep', 'Tower', 'Fortress', 'Stronghold'],
    Starverse: ['Space Station', 'Spacecraft', 'Spaceport', 'Spaceport', 'Spaceport'],
    Apocaverse: ['Ruins', 'Wasteland', 'Deserted City', 'Radioactive Zone', 'Radiation Field'],
    Viceverse: ['Police Station', 'Jail', 'Bureau', 'HQ', 'Office'],
    Heroverse: ['Hero Base', 'Hero Tower', 'Hero Compound', 'Hero Academy', 'Hero Retreat'],
    Waterverse: ['Ship', 'Boat', 'Submarine', 'Shipwreck', 'Island']
}


const ageOptions = ['Young', 'Middle-aged', 'Wizened'];
const buildOptions = ['Slender', 'Medium Build', 'Heavyset'];
const presentationOptions = ['Masculine', 'Feminine', 'Androgynous'];
const skinShadeOptions = ['Light', 'Medium', 'Dark'];
const hairStyleOptions = ['Bald', 'Short Straight', 'Short Curly', 'Long Straight', 'Long Wavy', 'Long Curly', 'Coiled/Kinky'];
const hairColorOptions = ['Light', 'Medium', 'Dark'];
const facialHairOptions = ['None', 'Mustache', 'Goatee', 'Sideburns', 'Full Beard'];
const eyeShapeOptions = ['Narrow', 'Almond', 'Average', 'Round'];
const noseShapeOptions = ['Narrow', 'Average', 'Broad'];
const lipsOptions = ['Thin', 'Average', 'Full'];



function MainMenu({ token, setToken, setThemeMode }) {
    const [settings, setSettings] = useState(null);
    const [games, setGames] = useState(null);
    const [view, setView] = useState(null);

    const [selectedWorld, setSelectedWorld] = useState(null);
    const [character, setCharacter] = useState({ name: '', archetype: '', appearance: {}, starting_location: '' });
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [expandedArchetype, setExpandedArchetype] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [gameId, setGameId] = useState(null);
    const BASE_URL = useContext(ApiContext);
    const navigate = useNavigate();
    const scrollRef = useRef(null);

    const isCharacterComplete = (char) => {
        const a = char.appearance || {};
        return (
            char.name &&
            char.starting_location &&
            char.archetype &&
            a.age_appearance &&
            a.build &&
            a.presentation &&
            a.skin_shade &&
            a.hair_color &&
            a.hair_style &&
            a.eye_shape &&
            a.nose_shape &&
            a.lips &&
            a.facial_hair
        );
    };



    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' }); // or just { top: 0 } if no animation
        }
    }, [view]);

    useEffect(() => {
        if (settings?.theme) {
            setThemeMode(settings.theme);
        }
    }, [settings, setThemeMode]);

    const playVoicePreview = (voice) => {
        const audio = new Audio(`${BASE_URL}/v1/preview-voice?voice=${voice}&token=${token}`);
        audio.play().catch(console.error);
    };


    useEffect(() => {
        const loadInitialData = async () => {
            try {
                const settingsResponse = await fetch(`${BASE_URL}/v1/settings`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (!settingsResponse.ok) throw new Error(`/settings HTTP ${settingsResponse.status}`);
                const settingsData = await settingsResponse.json();
                setSettings(settingsData);

                const gamesResponse = await fetch(`${BASE_URL}/v1/games`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (!gamesResponse.ok) throw new Error(`/games HTTP ${gamesResponse.status}`);
                const gamesData = await gamesResponse.json();
                setGames(gamesData);
                setView(gamesData.length > 0 ? 'load' : 'world');
            } catch (err) {
                console.error('Failed to load games or settings:', err);
                setError(`Failed to load games or settings (${err.message})`);
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            loadInitialData();
        }
    }, [BASE_URL, token]);

    const updateSetting = async (key, value) => {
        if (value === null) {
            return;
        }

        const newSettings = {
            ...settings,
            [key]: value
        };
        setSettings(newSettings);

        try {
            const response = await fetch(`${BASE_URL}/v1/settings`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(newSettings)
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);
        } catch (err) {
            console.error('Failed to save settings:', err);
            setError(`Failed to save settings (${err.message})`);
        }

    };



    const handleCreateGame = async () => {
        if (character.name.length < 1 || !selectedWorld || !character.archetype) return;

        try {
            setLoading(true);
            const response = await fetch(`${BASE_URL}/v1/new-game`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    character_name: character.name,
                    world: selectedWorld,
                    archetype: character.archetype,
                    appearance: character.appearance
                })
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            setGameId(data.id);
            setShowDialog(true);
        } catch (err) {
            console.error('Create game failed:', err);
            setError(`Failed to create game (${err.message})`);
        }
        finally {
            setLoading(false);
        }
    };

    const handleDialogClose = () => {
        setShowDialog(false);
        if (gameId) navigate(`/game/${gameId}`);
    };

    const handleNavClick = (targetView) => {
        setView(targetView);
        setDrawerOpen(false);
    };

    const handleRandomizeIdentity = () => {
        const syllables = [
            // Vowels
            'a', 'e', 'i', 'o', 'u',

            // Common 2-letter syllables
            'al', 'an', 'ar', 'el', 'en', 'er', 'in', 'ir', 'is', 'or', 'on', 'os', 'ul', 'un',

            // Classic 3-letter root chunks
            'bel', 'dor', 'fin', 'gar', 'hel', 'jor', 'kal', 'lin', 'mir',
            'nal', 'pan', 'quin', 'rin', 'sel', 'tor', 'val', 'ver', 'wyn',

            // A few punchy endings
            'eth', 'ian', 'ius', 'rek', 'zar', 'ra', 'dra'
        ];

        const syllableCount = Math.floor(Math.random() * 3) + 2; // 2 to 4 syllables
        let name = '';
        for (let i = 0; i < syllableCount; i++) {
            name += syllables[Math.floor(Math.random() * syllables.length)];
        }
        name = name.charAt(0).toUpperCase() + name.slice(1);

        const locationOptions = startingLocations[selectedWorld] || [];
        const starting_location =
            locationOptions[Math.floor(Math.random() * locationOptions.length)];

        setCharacter((prev) => ({
            ...prev,
            name,
            starting_location,
        }));
    };


    const handleRandomizeAppearance = () => {
        const rand = (list) => list[Math.floor(Math.random() * list.length)];

        const presentation = rand(presentationOptions)

        const randomAppearance = {
            age_appearance: rand(ageOptions),
            build: rand(buildOptions),
            presentation: presentation,
            skin_shade: rand(skinShadeOptions),
            hair_style: rand(hairStyleOptions),
            hair_color: rand(hairColorOptions),
            eye_shape: rand(eyeShapeOptions),
            nose_shape: rand(noseShapeOptions),
            lips: rand(lipsOptions),
            facial_hair: presentation === 'Masculine' ? rand(facialHairOptions) : 'None'
        };

        setCharacter((prev) => ({
            ...prev,
            appearance: randomAppearance
        }));
    };

    const hairStyle = character.appearance.hair_style;
    const facialHair = character.appearance.facial_hair;
    const hairColor = character.appearance.hair_color;

    let hairDescription = '';

    if (hairColor && hairStyle && facialHair) {

        if (hairStyle === 'Bald') {
            if (facialHair !== 'None') {
                hairDescription = `bald with ${facialHair.toLowerCase()}`;
            }
            else {
                hairDescription = 'bald';
            }
        } else {
            hairDescription = `${hairColor.toLowerCase()} ${hairStyle.toLowerCase()} hair`;
            if (facialHair !== 'None') {
                hairDescription += ` and ${facialHair.toLowerCase()}`;
            }
        }
    }

    if (loading) {
        return (
            <Box sx={{
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh',
                backgroundColor: (theme) => theme.palette.background.default,
                color: (theme) => theme.palette.text.primary,
            }}>
                <img src="/loading.gif" alt="loading.gif" style={{ height: '100px', width: 'auto' }} />
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh',
                backgroundColor: (theme) => theme.palette.background.default,
                color: (theme) => theme.palette.text.primary,
            }}>
                <Typography color="red">Error</Typography>
                <Typography>{error}</Typography>
                <Button onClick={() => setError(null)}>Retry</Button>
            </Box>
        );
    }

    return (
        <Box ref={scrollRef} sx={{
            height: '100vh', overflow: 'auto', display: 'flex', flexDirection: 'column',
            backgroundColor: (theme) => theme.palette.background.default,
            color: (theme) => theme.palette.text.primary,
        }}>
            {view === 'character' && (
                <IconButton
                    onClick={() => {
                        setCharacter({ ...character, archetype: '', starting_location: '' });
                        setView('world');
                    }}
                    sx={{ position: 'fixed', top: '10px', right: '20px', color: '#1876d2', zIndex: 1300 }}
                >
                    <ArrowBack />
                </IconButton>
            )}
            <Box sx={{ px: 1 }}>
                <IconButton
                    sx={{ position: 'fixed', top: '10px', left: '40px', transform: 'translateX(-50%)', color: '#1876d2', zIndex: 1300 }}
                    onClick={() => setDrawerOpen(!drawerOpen)}
                    edge="start"
                >
                    <MenuIcon />
                </IconButton>



                <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                    <Box sx={{ width: 250, mt: '50px' }}>
                        <List>
                            <ListItem button="true" onClick={() => handleNavClick('world')}>
                                <ListItemIcon><FontAwesomeIcon icon={faPlus} /></ListItemIcon>
                                <ListItemText primary="New Game" />
                            </ListItem>
                            <ListItem button="true" onClick={() => handleNavClick('load')}>
                                <ListItemIcon><FontAwesomeIcon icon={faFolderOpen} /></ListItemIcon>
                                <ListItemText primary="Load Game" />
                            </ListItem>
                            <ListItem button="true" onClick={() => handleNavClick('settings')}>
                                <ListItemIcon><SettingsIcon /></ListItemIcon>
                                <ListItemText primary="Settings" />
                            </ListItem>

                            <ListItem button="true" onClick={() => { setToken(null); localStorage.removeItem('token'); setDrawerOpen(false); }}>
                                <ListItemIcon><FontAwesomeIcon icon={faSignOutAlt} /></ListItemIcon>
                                <ListItemText primary="Logout" />
                            </ListItem>
                        </List>
                    </Box>
                </Drawer>

                <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 0, width: '100%' }}>



                    {view === 'settings' && (
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" sx={{ my: 3 }}>Settings</Typography>

                            {/* Theme selection */}
                            <TextField
                                label="Theme"
                                select
                                fullWidth
                                value={settings.theme}
                                onChange={(e) => updateSetting('theme', e.target.value)}
                                sx={{ mb: 2, width: '300px' }}
                            >
                                <MenuItem value="light">Light</MenuItem>
                                <MenuItem value="dark">Dark</MenuItem>
                                <MenuItem value="system">System</MenuItem>
                            </TextField>

                            {/* Voice Output Mode */}
                            <TextField
                                label="Voice Output"
                                select
                                fullWidth
                                value={settings.voice_output_mode}
                                onChange={(e) => updateSetting('voice_output_mode', e.target.value)}
                                sx={{ mb: 2, width: '300px' }}
                            >
                                <MenuItem value="off">Off</MenuItem>
                                <MenuItem value="on">On</MenuItem>

                            </TextField>

                            {/* Voice selection only if voice_mode !== off */}
                            {settings.voice_output_mode !== 'off' && (
                                <Box sx={{

                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <TextField
                                        label="AI Voice"
                                        select
                                        value={settings.voice}
                                        onChange={(e) => updateSetting('voice', e.target.value)}
                                        sx={{ mb: 2, width: '250px' }}
                                    >
                                        {[
                                            'alloy', 'ash', 'ballad', 'coral', 'echo', 'sage', 'shimmer', 'verse'
                                            //'fable', 'onyx', 'nova',
                                        ].map((v) => (
                                            <MenuItem key={v} value={v}>{v.charAt(0).toUpperCase() + v.slice(1)}</MenuItem>
                                        ))}
                                    </TextField>
                                    <Tooltip title="Preview voice">
                                        <IconButton sx={{ ml: 1, mt: 1 }} onClick={() => playVoicePreview(settings.voice)}>
                                            <PlayArrowIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            )}

                            {/* Voice Input Mode */}
                            <TextField
                                label="Voice Input"
                                select
                                fullWidth
                                value={settings.voice_input_mode}
                                onChange={(e) => updateSetting('voice_input_mode', e.target.value)}
                                sx={{ mb: 2, width: '300px' }}
                            >
                                <MenuItem value="off">Off</MenuItem>
                                <MenuItem value="record">Record Button</MenuItem>
                                <MenuItem value="vad">Voice Activation</MenuItem>
                            </TextField>


                            {/* VAD Type (only if voice_mode is vad) */}
                            {settings.voice_input_mode === 'vad' && (
                                <TextField
                                    label="VAD Type"
                                    select
                                    value={settings.vad_type}
                                    onChange={(e) => updateSetting('vad_type', e.target.value)}
                                    sx={{ mb: 2, width: '300px' }}
                                >
                                    <MenuItem value="semantic">Semantic</MenuItem>
                                    <MenuItem value="silence">Silence</MenuItem>
                                </TextField>
                            )}

                            {/* Semantic VAD Settings */}
                            {settings.voice_input_mode === 'vad' && settings.vad_type === 'semantic' && (
                                <Box sx={{ alignItems: 'center' }}>
                                    <TextField
                                        label="Semantic VAD Eagerness"
                                        select
                                        value={settings.semantic_eagerness}
                                        onChange={(e) => updateSetting('semantic_eagerness', e.target.value)}
                                        sx={{ mb: 2, width: '250px' }}
                                    >
                                        <MenuItem value="low">Low</MenuItem>
                                        <MenuItem value="medium">Medium</MenuItem>
                                        <MenuItem value="high">High</MenuItem>
                                    </TextField>
                                    <Tooltip title="How quickly a speech turn is considered complete.  Lower settings reduce the risk of being cut off prematurely but may result in longer pauses before the AI responds.">
                                        <IconButton sx={{ ml: 1, mt: 1 }}>
                                            <HelpOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            )}

                            {/* Silence VAD Settings */}
                            {settings.voice_input_mode === 'vad' && settings.vad_type === 'silence' && (
                                <>
                                    <Box sx={{ alignItems: 'center' }}>
                                        <TextField
                                            label="Activation Threshold"
                                            type="number"
                                            value={settings.threshold}
                                            onChange={(e) => updateSetting('threshold', parseFloat(e.target.value))}
                                            sx={{ mb: 2, width: '250px' }}
                                            slotProps={{
                                                htmlInput: {
                                                    step: 0.1,
                                                    min: 0,
                                                    max: 1
                                                }
                                            }}
                                        />
                                        <Tooltip title="Higher = less sensitive (useful in noisy environments)">
                                            <IconButton sx={{ ml: 1, mt: 1 }}>
                                                <HelpOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>

                                    <Box sx={{ alignItems: 'center' }}>
                                        <TextField
                                            label="Prefix Padding (ms)"
                                            type="number"
                                            value={settings.prefix_padding_ms}
                                            onChange={(e) => updateSetting('prefix_padding_ms', parseInt(e.target.value))}
                                            sx={{ mb: 2, width: '250px' }}
                                            slotProps={{
                                                htmlInput: {
                                                    step: 100,
                                                    min: 0,
                                                    max: 1000
                                                }
                                            }}
                                        />
                                        <Tooltip title="How much audio to keep before speech is initially detected.">
                                            <IconButton sx={{ ml: 1, mt: 1 }}>
                                                <HelpOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>

                                    <Box sx={{ alignItems: 'center', mb: 2 }}>
                                        <TextField
                                            label="Silence Duration (ms)"
                                            type="number"
                                            value={settings.silence_duration_ms}
                                            onChange={(e) => updateSetting('silence_duration_ms', parseInt(e.target.value))}
                                            sx={{ mb: 2, width: '250px' }}
                                            slotProps={{
                                                htmlInput: {
                                                    step: 100,
                                                    min: 300,
                                                    max: 3000
                                                }
                                            }}
                                        />
                                        <Tooltip title="How much silence is required before ending the speech segment.  Set higher to accomodate longer pauses.">
                                            <IconButton sx={{ ml: 1, mt: 1 }}>
                                                <HelpOutlineIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </>
                            )}
                        </Box>
                    )}



                    {view === 'load' && (
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" sx={{ my: 3 }}>Load Game</Typography>
                            {games.length > 0 ? (
                                games.map((game) => (
                                    <Box key={game.id} sx={{ px: 1 }}>
                                        <Paper
                                            key={game.id}
                                            variant="outlined"
                                            sx={{
                                                mb: 2,
                                                p: 2,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                            }}
                                        >
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Typography variant="subtitle1" fontWeight="bold">
                                                        {game.character_name}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
                                                        {game.archetype} · {game.world}
                                                    </Typography>
                                                </Box>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => navigate(`/game/${game.id}`)}
                                                    sx={{ ml: 2 }}
                                                >
                                                    Load
                                                </Button>
                                            </Box>
                                        </Paper>
                                    </Box>
                                ))
                            ) : (
                                <Typography>No saved games.</Typography>
                            )}
                        </Box>
                    )}

                    {view === 'world' && (
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h5" sx={{ my: 3 }}>Choose Multiverse</Typography>
                            {multiverses.map(({ id, name, icon, description }) => (
                                <Box key={id} sx={{ px: 1 }}>
                                    <Paper
                                        key={id}
                                        elevation={3}
                                        sx={{
                                            p: 2,
                                            mb: 2,
                                            textAlign: 'left',
                                            cursor: 'pointer',
                                            color: selectedWorld === id ? 'white' : (theme) => theme.palette.color,
                                            backgroundColor: selectedWorld === id ? '#1876d2' : (theme) => theme.palette.background.paper
                                        }}
                                        onClick={() => { setSelectedWorld(id); setView('character'); }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                            {icon}
                                            <Typography variant="h6">{name}</Typography>
                                        </Box>
                                        <Typography variant="body2">{description}</Typography>
                                    </Paper>
                                </Box>
                            ))}
                        </Box>
                    )}

                    {view === 'character' && (
                        <Box>
                            <Box sx={{ position: 'relative', my: 3 }}>
                                <Typography variant="h5" align="center">
                                    Create Character
                                </Typography>

                            </Box>


                            <Typography variant="subtitle1" sx={{ mb: 2 }}>Choose your <strong>archetype</strong> (<em>{selectedWorld}</em>)...</Typography>

                            {archetypesByWorld[selectedWorld]?.map(({ id, details }) => (
                                <Box key={id} sx={{ px: 1 }}>
                                    <Paper
                                        key={id}
                                        elevation={1}
                                        sx={{
                                            p: 1.5,
                                            my: 1,
                                            cursor: 'pointer',
                                            color: character.archetype === id ? 'white' : (theme) => theme.palette.color,
                                            backgroundColor: character.archetype === id ? '#1876d2' : (theme) => theme.palette.background.paper
                                        }}
                                        onClick={() => setCharacter({ ...character, archetype: id })}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box>
                                                <Typography variant="subtitle1">{id}</Typography>
                                            </Box>
                                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); setExpandedArchetype(expandedArchetype === id ? null : id); }}>
                                                {expandedArchetype === id ? <ExpandLessIcon sx={{ color: character.archetype === id ? 'white' : (theme) => theme.palette.color }} /> : <ExpandMoreIcon sx={{ color: character.archetype === id ? 'white' : (theme) => theme.palette.color }} />}
                                            </IconButton>
                                        </Box>
                                        <Collapse in={expandedArchetype === id}>
                                            <Typography variant="body2" sx={{ mt: 1, whiteSpace: 'pre-line' }}>
                                                {details}
                                            </Typography>

                                        </Collapse>
                                    </Paper>
                                </Box>
                            ))}


                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 4, mb: 2 }}>
                                <Typography variant="subtitle1">
                                    Choose your <strong>appearance</strong>...
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={handleRandomizeAppearance}
                                    aria-label="Randomize appearance"
                                >
                                    <CasinoIcon />
                                </IconButton>
                            </Box>


                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, px: 1 }}>
                                {/* Row 1: Age, Build */}
                                <TextField
                                    label="Age"
                                    select
                                    fullWidth
                                    value={character.appearance.age_appearance || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, age_appearance: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {ageOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    label="Build"
                                    select
                                    fullWidth
                                    value={character.appearance.build || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, build: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {buildOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>

                                {/* Row 2: Presentation, Skin Shade */}

                                <TextField
                                    label="Skin Shade"
                                    select
                                    fullWidth
                                    value={character.appearance.skin_shade || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, skin_shade: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {skinShadeOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    label="Presentation"
                                    select
                                    fullWidth
                                    value={character.appearance.presentation || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, presentation: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {presentationOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>



                                {/* Row 3: Hair Style, Hair Color */}
                                <TextField
                                    label="Hair Style"
                                    select
                                    fullWidth
                                    value={character.appearance.hair_style || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, hair_style: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {hairStyleOptions.map((style) => (
                                        <MenuItem key={style} value={style}>{style}</MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    label="Hair Color"
                                    select
                                    fullWidth
                                    value={character.appearance.hair_color || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, hair_color: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {hairColorOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>

                                {/* Row 4: Eye Shape, Nose Shape */}
                                <TextField
                                    label="Eye Shape"
                                    select
                                    fullWidth
                                    value={character.appearance.eye_shape || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, eye_shape: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {eyeShapeOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    label="Nose Shape"
                                    select
                                    fullWidth
                                    value={character.appearance.nose_shape || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, nose_shape: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {noseShapeOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>

                                {/* Row 5: Facial Hair, Lips */}
                                <TextField
                                    label="Facial Hair"
                                    select
                                    fullWidth
                                    value={character.appearance.facial_hair || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, facial_hair: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {facialHairOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    label="Lips"
                                    select
                                    fullWidth
                                    value={character.appearance.lips || ''}
                                    onChange={(e) =>
                                        setCharacter({ ...character, appearance: { ...character.appearance, lips: e.target.value } })
                                    }
                                    sx={{ flex: '1 1 calc(50% - 8px)' }}
                                >
                                    {lipsOptions.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>
                            </Box>




                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 4, mb: 2 }}>
                                <Typography variant="subtitle1">
                                    Choose your <strong>name</strong> and <strong>starting location</strong>...
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={handleRandomizeIdentity}
                                    aria-label="Randomize name and location"
                                >
                                    <CasinoIcon />
                                </IconButton>
                            </Box>

                            <Box sx={{ alignItems: 'center', px: 1 }}>

                                <TextField
                                    label="Name"
                                    fullWidth
                                    value={character.name}
                                    onChange={(e) => setCharacter({ ...character, name: e.target.value })}
                                    sx={{ mb: 2 }}
                                />

                                <TextField
                                    label="Starting Location"
                                    select
                                    fullWidth
                                    value={character.starting_location}
                                    onChange={(e) => setCharacter({ ...character, starting_location: e.target.value })}
                                    sx={{ mb: 2 }}
                                >
                                    {startingLocations[selectedWorld]?.map((value) => (
                                        <MenuItem key={value} value={value}>{value}</MenuItem>
                                    ))}
                                </TextField>

                                <Box sx={{ mt: 1 }}>
                                    <Paper
                                        elevation={2}
                                        sx={{
                                            p: 2,
                                            textAlign: 'center',
                                            backgroundColor: (theme) =>
                                                theme.palette.mode === 'dark' ? '#1e1e1e' : '#e8f1fb',
                                            border: '1px solid',
                                            borderColor: (theme) =>
                                                theme.palette.mode === 'dark' ? '#333' : '#c7dff6',
                                        }}
                                    >
                                        {isCharacterComplete(character) ? (
                                            <Typography variant="body1">
                                                Your name is <strong>{character.name}</strong> and you are a{' '}
                                                <strong>{character.appearance.age_appearance.toLowerCase()}</strong>,{' '}
                                                <strong>{character.appearance.build.toLowerCase()}</strong>,{' '}
                                                <strong>{character.appearance.presentation.toLowerCase()}</strong>{' '}
                                                <strong>{character.archetype}</strong>{' '}

                                                with <strong>{character.appearance.skin_shade.toLowerCase()} skin tone</strong>
                                                {hairDescription && (
                                                    <>
                                                        {', '}
                                                        <strong>{hairDescription}</strong>
                                                    </>
                                                )}
                                                {', '}
                                                <strong>{character.appearance.eye_shape.toLowerCase()} eyes</strong>, a{' '}
                                                <strong>{character.appearance.nose_shape.toLowerCase()} nose</strong>, and{' '}
                                                <strong>{character.appearance.lips.toLowerCase()} lips</strong>.
                                                You will wake up at a <strong>{character.starting_location}</strong> in <strong>{selectedWorld}</strong>.
                                            </Typography>
                                        ) : (
                                            <Typography color="text.secondary">
                                                Finish defining your character before proceeding.
                                            </Typography>
                                        )}
                                    </Paper>
                                </Box>



                                <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{ my: 3 }}
                                    onClick={handleCreateGame}
                                    disabled={
                                        !isCharacterComplete(character)
                                    }
                                >
                                    Create Game
                                </Button>

                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>

            <Dialog open={showDialog} onClose={handleDialogClose}>
                <DialogTitle>Give it a moment...</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Initializing your character and world may take a couple of minutes.  You’ll be launched into the game shortly.  Thank you for your patience!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>OK</Button>
                </DialogActions>
            </Dialog>
        </Box >
    );
}

export default MainMenu;
